import {
  Avatar,
  Box,
  Grid,
  Stack,
  Typography
} from "@mui/material";
import {
  styled
} from "@mui/material/styles";

export const OwnerNameTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  fontSize: "14px",
  fontWeight: "700",
  lineHeight: "21px"
}));

export const SubtitleTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "18px",
  width:"100%",

  [theme.breakpoints.down("sm")]:{
    paddingRight: "0"
  }
}));

export const TitleTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  fontSize: "1.25rem",
  fontWeight: "700",
  lineHeight: "1.75rem",

  [theme.breakpoints.down("sm")]:{
    lineHeight: "1.875rem",
    width:"100%"
  }
}));

export const BodyTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  fontSize: "0.875rem",
  fontWeight: "400",
  lineHeight: "1.25rem",
  margin: "0 !important",

  "& p": {
    margin: "0 !important"
  },

  [theme.breakpoints.down("sm")]:{
    paddingRight: "0px"
  }
}));

export const SectionTitleTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.accentVariantA,
  fontSize: "1.25rem",
  fontWeight: "700",
  lineHeight: "28px"
}));

export const AttachmentPill = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  border: `1px solid ${theme.customColors.inputBorder}`,
  borderRadius: "8px",
  boxSizing: "border-box",
  cursor: "pointer",
  flexDirection: "row",
  gap: "16px",
  minHeight: "32px",
  padding: "8px",
  width: "100%"
}));

export const AttachmentNameTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  flexGrow: 1,
  fontSize: "12px",
  fontWeight: "400",
  lineHeight: "16px",
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}));

export const LinkTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.backgroundPrimaryCta,
  fontSize: "18px",
  fontWeight: "500",
  lineHeight: "22px"
}));

export const LinkInfoTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textDisabledAlternative,
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "22px"
}));

export const ContentStack = styled(Stack)(({ theme }) => ({
  "& svg": {
    stroke: theme.customColors.exploreCardText
  }
}));

export const AuthorAvatar = styled(Avatar)(({ theme }) => ({
  height: "40px",
  width: "40px",
  [theme.breakpoints.down("sm")]: {
    height: "32px",
    width: "32px"
  }
}));

export const TopicCardDetailsBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection:"column",
  position:"relative",
  "main":{
    borderBottom:`1px solid ${theme.customColors.border}`,
    marginBottom:theme.spacing(5),
    paddingBottom:theme.spacing(5),

    [theme.breakpoints.down("sm")]:{
      marginBottom:theme.spacing(3),
      paddingBottom:theme.spacing(1)
    },

    "&:has(> .video-caption)": {
      borderBottom: "none"
    }
  }

}));

export const HeroGridMain = styled(Grid)<{ $cover?: string }>(({ theme, $cover }) => ({
  backgroundColor: theme.customColors.backgroundPrimary,
  background: $cover
    ? `url(${$cover})`
    : theme.customColors.backgroundPrimary,
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  padding: theme.spacing("32px", "40px"),
  position: "relative",
  overflow: "hidden",
  borderBottom: `0.125rem solid ${theme.customColors.border}`,
  transition: "all 0.35s ease-out",
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing("24px", 2.5, 5),
    ...($cover && {
      minHeight: "27.5rem"
    })
  },

  "& p": {
    color: theme.customColors.exploreCardText
  }
}));

export const HeroContentWrapper = styled(Stack)(({ theme }) => ({
  position: "relative",
  zIndex: 3,
  flexGrow: 1,
  gap: "1.5rem",
  flexDirection: "column",
  [theme.breakpoints.down("sm")]: {
    justifyContent: "flex-end"
  }
}));
